import clsx from 'clsx';
import { FC, HTMLAttributes } from 'react';

export const Sidebar: FC<HTMLAttributes<HTMLElement>> = ({ children, className, ...props }) => {
  return (
    <nav {...props} className={clsx('border-secondary-std flex w-full w-[20rem] border-x bg-white bg-opacity-80')}>
      <div className={clsx('flex flex-1 flex-col', className)}>{children}</div>
    </nav>
  );
};
